require('es6-promise').polyfill()
import axios from 'axios'
import store from '@/vuex/store'
import i18n from '@/message/i18n.js'
import { MessageBox } from 'element-ui';
let url = require('@/../config/sysConfig')

const Service = axios.create({
  //baseURL: url.axiosBaseURL,
  baseURL: process.env.NODE_ENV === "development" ? "/" : url.axiosBaseURL,
  crossDomain: true,
  withCredentials: true,
  timeout: 300000,
})
Service.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded'

Service.interceptors.request.use(function (config) {
  config.headers['Authorization'] = $cookies.get('token')
  config.headers['FrontendVersion'] = i18n.t('COMMON.LBL_VER').replace("Ver.", ""); 
  return config
}, function (error) {
  return Promise.reject(error)
})
Service.interceptors.response.use(
  response => {
    //hostnameを取得
    store.commit('set_hostname', response.headers['hostname']);
    return response;
  },
  error => {
    console.log('response異常');
    // 判断请求异常信息中是否含有超时timeout字符串
    if (error.message.includes('401')) {
      store.state.routerObj.replace({ path: '/login' });
    } else if (error.message.includes('400') || error.message.includes('405') || error.message.includes('500')) {
      store.state.routerObj.replace({ path: '/error' });
    } else if (error.message.includes('302')) {
      //弹出升级重刷新确认框
      MessageBox.alert(i18n.t('COMMON.MSG_VER_UPDATE_CONFIRM'), {
        confirmButtonText: i18n.t('COMMON.BTN_CONFIRM'),
        type: 'warning',
        center: 'true'
      }).then(() => {
        //this.$router.push({ path: "/login"});
        window.location.reload(true);
      }).catch(() => {
        //this.$router.push({ path: "/login"});
        window.location.reload(true);
      })
    } else if (error.message.includes('timeout')) {
      alert(i18n.t('COMMON.MSG_ERROR_TIMEOUT'));
    } else if (error.message.includes('Network Error')) {
      alert(i18n.t('COMMON.MSG_NETWORK_ERROR'));
    }
    return Promise.reject(error);
  }
)

export default {
  //get请求
  requestGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      Service.get(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //get请求不带参数
  requestQuickGet(url) {
    return new Promise((resolve, reject) => {
      Service.get(url).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //post请求
  requestPost(url, params = {}) {
    return new Promise((resolve, reject) => {
      Service.post(url, params).then(res => {
        // var token = '';
        // if (url == '/mobile/j_spring_security_check') {
        //   try {
        //     token = res.data.items[0].token;
        //     if (token != '' && token != null && token != undefined) {
        //       $cookies.set('token',token,'1d');
        //     }
        //   } catch (e) {
        //     console.log(e);
        //   }
        // }
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //post请求
  requestPostForm(url, params = {}) {
    return new Promise((resolve, reject) => {
      Service.post(url, params, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'accept': '*/*',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(res => {
        resolve(res.data)//注意res是axios封装的对象，res.data才是服务端返回的信息
      }).catch(error => {
        reject(error)
      })
    })
  },
  // //put图片请求 form-data请求
  requestPostFormData(url, params = []) {
    return new Promise((resolve, reject) => {
      Service.put(url, params, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  //put请求
  requestPut(url, params = {}) {
    return new Promise((resolve, reject) => {
      Service.put(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //delete请求
  requestDelete(url, params = {}) {
    return new Promise((resolve, reject) => {
      Service.delete(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //get图片请求
  requestQuickGetImage(url) {
    return new Promise((resolve, reject) => {
      Service.get(url, { responseType: 'arraybuffer' }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //post zip请求
  requestPostZip(url, params = {}) {
    return new Promise((resolve, reject) => {
      Service.post(url, params, { responseType: 'blob' }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/base/api/public.js